import computed from './computed'

export default {
  computed: computed.computed
  // created () {
  //   this._deptFilter_ = {}
  // }
}



// WEBPACK FOOTER //
// ./src/public/mixins/index.js